export enum VideoPlatform {
  Zoom = "zoom",
  Twilio = "twilio",
}
